import React from 'react'
import { useSelector } from 'react-redux'

import BaseEntity from 'app/components/BaseEntity'
import constants from 'app/constants'
import {
  fetchPreschoolSpiralLoData,
  updatePreschoolData
} from 'app/store/actions/preschoolEntity'

import { columns } from './config'

/**
 * Spiral LOs admin page — the month-by-month goals.
 *
 * CRUD against /api/v1/preschool-evaluation/admin/spiral-los/ via the
 * preschoolEntity saga. Filter `annual_lo_inferred=true` (Inferred column)
 * to review the positionally-inferred Annual-LO links from the seed.
 */
const SpiralLOs = () => {
  const data = useSelector(
    (state) => state.preschoolEntityReducer.preschoolSpiralLoData
  )

  return (
    <BaseEntity
      entity={constants.PRESCHOOL_SPIRAL_LO}
      label={constants.PRESCHOOL_SPIRAL_LO_LABEL}
      columns={columns}
      data={data}
      fetchData={fetchPreschoolSpiralLoData}
      updateEntityData={updatePreschoolData}
    />
  )
}

export default SpiralLOs
